export default "__VITE_ASSET__C9PzCM5S__"